module.exports = __webpack_public_path__ + "static/contact_en-903d1225cb2c0052f62f5ef6628e9461.svg";